module.exports = __webpack_public_path__ + "img/check-mark.0d4e03c5.svg";